goog.provide("shadow.js.shim.module$$mui$material$DialogContent");
goog.provide("module$shadow_js_shim_module$$mui$material$DialogContent");
shadow.js.shim.module$$mui$material$DialogContent = shadow.js.nativeProvides["@mui/material/DialogContent"] = shadow$bridge("@mui/material/DialogContent");
module$shadow_js_shim_module$$mui$material$DialogContent.default = shadow.js.shim.module$$mui$material$DialogContent;
